<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">
    {{ data.cancelText }}
  </button>

  <button mat-raised-button [color]="data.confirmColor" (click)="confirm()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
